<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import {
  cookieTools,
  addBar,
  hideBar,
  addGaScripts,
} from '@streeva/very-simple-cookie-consent'
import '~cookieconsent/dist/style.css'
import addRecaptchaScript from '@/components/recaptchaScript'
import addCfBeaconScript from '@/components/cloudflareInsightsBeaconScript'
import addJiraServiceDeskScript from '@/components/jiraServiceDeskScript'

const getBaseDomain = () => {
  const hostname = window.location.hostname
  if (hostname.includes('localhost')) return 'localhost'
  if (hostname.includes('onrender.com')) return hostname

  const match = hostname.match(/\w*\.*?(com|co.uk|net)$/gi)
  let domain = ''

  if (match) {
    domain = match[0]
  } else {
    domain = hostname
  }

  return `.${domain}`
}

const TAG = 'GTM-WSKPJM7'
const privacyPolicyLink = 'https://www.swiftaid.co.uk/legal/cookies/'
const ct = cookieTools.init({
  domain: getBaseDomain(),
  expires: 365,
  sameSite: 'Lax',
})

/**
 * Approve consent handler
 *
 * @param e
 */
const approveHandler = (e: any) => {
  e.preventDefault()
  hideBar()
  ct.approve()
  // load GA script
  addGaScripts(TAG)
}
/**
 * Decline consent handler
 *
 * @param e
 */
const declineHandler = (e: any) => {
  e.preventDefault()
  hideBar()
  ct.decline()
}

onMounted(() => {
  addRecaptchaScript()
  addCfBeaconScript()

  if (import.meta.env.MODE !== 'mockapi') {
    addJiraServiceDeskScript()
  }

  // Check has approved or declined cookies
  if (!ct.hasMadeChoice()) {
    // Show consent bar
    addBar(privacyPolicyLink, approveHandler, declineHandler)
    return
  }

  // Check has approved cookies
  if (ct.hasConsent()) {
    // load GA scripts
    addGaScripts(TAG)
    return
  }
})
</script>

<template>
  <RouterView />
</template>
